export default __webpack_public_path__ + "static/media/logo-full.31cda5d3.jpg";